// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: superchart-page.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { TimeBucket_TimeSeries, timeBucket_TimeSeriesFromJSON, timeBucket_TimeSeriesToJSON } from "./common";
import { Indicator } from "./indicator";
import { ExchangeTradingSession } from "./trading-calendar";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.superchart";

export interface SuperChartConfiguration {
  timeBuckets: SuperChartConfiguration_TimeBucket[];
  dateRanges: SuperChartConfiguration_DateRange[];
  chartTypes: SuperChartConfiguration_ChartType[];
  indicators: Indicator[];
  exchangeTradingSessions: ExchangeTradingSession[];
}

export interface SuperChartConfiguration_TimeBucket {
  code: string;
  name: string;
  timeSeries: TimeBucket_TimeSeries;
  timeValue: number;
}

export interface SuperChartConfiguration_DateRange {
  code: string;
  name: string;
  description: string;
  timeBucketCode: string;
  startTime: number;
  endTime: number;
  durationInMinutes: number;
}

export interface SuperChartConfiguration_ChartType {
  code: string;
  name: string;
  description: string;
  icon: string;
  group: string;
}

export interface WebsiteSuperChartConfiguration {
  dateRanges: SuperChartConfiguration_DateRange[];
  timeBuckets: SuperChartConfiguration_TimeBucket[];
}

function createBaseSuperChartConfiguration(): SuperChartConfiguration {
  return { timeBuckets: [], dateRanges: [], chartTypes: [], indicators: [], exchangeTradingSessions: [] };
}

export const SuperChartConfiguration = {
  encode(message: SuperChartConfiguration, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.timeBuckets) {
      SuperChartConfiguration_TimeBucket.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.dateRanges) {
      SuperChartConfiguration_DateRange.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.chartTypes) {
      SuperChartConfiguration_ChartType.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.indicators) {
      Indicator.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.exchangeTradingSessions) {
      ExchangeTradingSession.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SuperChartConfiguration {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperChartConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeBuckets.push(SuperChartConfiguration_TimeBucket.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.dateRanges.push(SuperChartConfiguration_DateRange.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.chartTypes.push(SuperChartConfiguration_ChartType.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.indicators.push(Indicator.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.exchangeTradingSessions.push(ExchangeTradingSession.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuperChartConfiguration {
    return {
      timeBuckets: globalThis.Array.isArray(object?.timeBuckets)
        ? object.timeBuckets.map((e: any) => SuperChartConfiguration_TimeBucket.fromJSON(e))
        : [],
      dateRanges: globalThis.Array.isArray(object?.dateRanges)
        ? object.dateRanges.map((e: any) => SuperChartConfiguration_DateRange.fromJSON(e))
        : [],
      chartTypes: globalThis.Array.isArray(object?.chartTypes)
        ? object.chartTypes.map((e: any) => SuperChartConfiguration_ChartType.fromJSON(e))
        : [],
      indicators: globalThis.Array.isArray(object?.indicators)
        ? object.indicators.map((e: any) => Indicator.fromJSON(e))
        : [],
      exchangeTradingSessions: globalThis.Array.isArray(object?.exchangeTradingSessions)
        ? object.exchangeTradingSessions.map((e: any) => ExchangeTradingSession.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SuperChartConfiguration): unknown {
    const obj: any = {};
    if (message.timeBuckets?.length) {
      obj.timeBuckets = message.timeBuckets.map((e) => SuperChartConfiguration_TimeBucket.toJSON(e));
    }
    if (message.dateRanges?.length) {
      obj.dateRanges = message.dateRanges.map((e) => SuperChartConfiguration_DateRange.toJSON(e));
    }
    if (message.chartTypes?.length) {
      obj.chartTypes = message.chartTypes.map((e) => SuperChartConfiguration_ChartType.toJSON(e));
    }
    if (message.indicators?.length) {
      obj.indicators = message.indicators.map((e) => Indicator.toJSON(e));
    }
    if (message.exchangeTradingSessions?.length) {
      obj.exchangeTradingSessions = message.exchangeTradingSessions.map((e) => ExchangeTradingSession.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuperChartConfiguration>, I>>(base?: I): SuperChartConfiguration {
    return SuperChartConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuperChartConfiguration>, I>>(object: I): SuperChartConfiguration {
    const message = createBaseSuperChartConfiguration();
    message.timeBuckets = object.timeBuckets?.map((e) => SuperChartConfiguration_TimeBucket.fromPartial(e)) || [];
    message.dateRanges = object.dateRanges?.map((e) => SuperChartConfiguration_DateRange.fromPartial(e)) || [];
    message.chartTypes = object.chartTypes?.map((e) => SuperChartConfiguration_ChartType.fromPartial(e)) || [];
    message.indicators = object.indicators?.map((e) => Indicator.fromPartial(e)) || [];
    message.exchangeTradingSessions =
      object.exchangeTradingSessions?.map((e) => ExchangeTradingSession.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSuperChartConfiguration_TimeBucket(): SuperChartConfiguration_TimeBucket {
  return { code: "", name: "", timeSeries: 0, timeValue: 0 };
}

export const SuperChartConfiguration_TimeBucket = {
  encode(message: SuperChartConfiguration_TimeBucket, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.timeSeries !== 0) {
      writer.uint32(24).int32(message.timeSeries);
    }
    if (message.timeValue !== 0) {
      writer.uint32(32).int32(message.timeValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SuperChartConfiguration_TimeBucket {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperChartConfiguration_TimeBucket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.timeSeries = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.timeValue = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuperChartConfiguration_TimeBucket {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      timeSeries: isSet(object.timeSeries) ? timeBucket_TimeSeriesFromJSON(object.timeSeries) : 0,
      timeValue: isSet(object.timeValue) ? globalThis.Number(object.timeValue) : 0,
    };
  },

  toJSON(message: SuperChartConfiguration_TimeBucket): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.timeSeries !== 0) {
      obj.timeSeries = timeBucket_TimeSeriesToJSON(message.timeSeries);
    }
    if (message.timeValue !== 0) {
      obj.timeValue = Math.round(message.timeValue);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuperChartConfiguration_TimeBucket>, I>>(
    base?: I,
  ): SuperChartConfiguration_TimeBucket {
    return SuperChartConfiguration_TimeBucket.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuperChartConfiguration_TimeBucket>, I>>(
    object: I,
  ): SuperChartConfiguration_TimeBucket {
    const message = createBaseSuperChartConfiguration_TimeBucket();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.timeSeries = object.timeSeries ?? 0;
    message.timeValue = object.timeValue ?? 0;
    return message;
  },
};

function createBaseSuperChartConfiguration_DateRange(): SuperChartConfiguration_DateRange {
  return { code: "", name: "", description: "", timeBucketCode: "", startTime: 0, endTime: 0, durationInMinutes: 0 };
}

export const SuperChartConfiguration_DateRange = {
  encode(message: SuperChartConfiguration_DateRange, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.timeBucketCode !== "") {
      writer.uint32(42).string(message.timeBucketCode);
    }
    if (message.startTime !== 0) {
      writer.uint32(56).int64(message.startTime);
    }
    if (message.endTime !== 0) {
      writer.uint32(64).int64(message.endTime);
    }
    if (message.durationInMinutes !== 0) {
      writer.uint32(72).int32(message.durationInMinutes);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SuperChartConfiguration_DateRange {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperChartConfiguration_DateRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.timeBucketCode = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.startTime = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.endTime = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.durationInMinutes = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuperChartConfiguration_DateRange {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      timeBucketCode: isSet(object.timeBucketCode) ? globalThis.String(object.timeBucketCode) : "",
      startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : 0,
      endTime: isSet(object.endTime) ? globalThis.Number(object.endTime) : 0,
      durationInMinutes: isSet(object.durationInMinutes) ? globalThis.Number(object.durationInMinutes) : 0,
    };
  },

  toJSON(message: SuperChartConfiguration_DateRange): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.timeBucketCode !== "") {
      obj.timeBucketCode = message.timeBucketCode;
    }
    if (message.startTime !== 0) {
      obj.startTime = Math.round(message.startTime);
    }
    if (message.endTime !== 0) {
      obj.endTime = Math.round(message.endTime);
    }
    if (message.durationInMinutes !== 0) {
      obj.durationInMinutes = Math.round(message.durationInMinutes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuperChartConfiguration_DateRange>, I>>(
    base?: I,
  ): SuperChartConfiguration_DateRange {
    return SuperChartConfiguration_DateRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuperChartConfiguration_DateRange>, I>>(
    object: I,
  ): SuperChartConfiguration_DateRange {
    const message = createBaseSuperChartConfiguration_DateRange();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.timeBucketCode = object.timeBucketCode ?? "";
    message.startTime = object.startTime ?? 0;
    message.endTime = object.endTime ?? 0;
    message.durationInMinutes = object.durationInMinutes ?? 0;
    return message;
  },
};

function createBaseSuperChartConfiguration_ChartType(): SuperChartConfiguration_ChartType {
  return { code: "", name: "", description: "", icon: "", group: "" };
}

export const SuperChartConfiguration_ChartType = {
  encode(message: SuperChartConfiguration_ChartType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.icon !== "") {
      writer.uint32(34).string(message.icon);
    }
    if (message.group !== "") {
      writer.uint32(42).string(message.group);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SuperChartConfiguration_ChartType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperChartConfiguration_ChartType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.icon = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.group = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuperChartConfiguration_ChartType {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      icon: isSet(object.icon) ? globalThis.String(object.icon) : "",
      group: isSet(object.group) ? globalThis.String(object.group) : "",
    };
  },

  toJSON(message: SuperChartConfiguration_ChartType): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.icon !== "") {
      obj.icon = message.icon;
    }
    if (message.group !== "") {
      obj.group = message.group;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuperChartConfiguration_ChartType>, I>>(
    base?: I,
  ): SuperChartConfiguration_ChartType {
    return SuperChartConfiguration_ChartType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuperChartConfiguration_ChartType>, I>>(
    object: I,
  ): SuperChartConfiguration_ChartType {
    const message = createBaseSuperChartConfiguration_ChartType();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.icon = object.icon ?? "";
    message.group = object.group ?? "";
    return message;
  },
};

function createBaseWebsiteSuperChartConfiguration(): WebsiteSuperChartConfiguration {
  return { dateRanges: [], timeBuckets: [] };
}

export const WebsiteSuperChartConfiguration = {
  encode(message: WebsiteSuperChartConfiguration, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.dateRanges) {
      SuperChartConfiguration_DateRange.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.timeBuckets) {
      SuperChartConfiguration_TimeBucket.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebsiteSuperChartConfiguration {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebsiteSuperChartConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.dateRanges.push(SuperChartConfiguration_DateRange.decode(reader, reader.uint32()));
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeBuckets.push(SuperChartConfiguration_TimeBucket.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebsiteSuperChartConfiguration {
    return {
      dateRanges: globalThis.Array.isArray(object?.dateRanges)
        ? object.dateRanges.map((e: any) => SuperChartConfiguration_DateRange.fromJSON(e))
        : [],
      timeBuckets: globalThis.Array.isArray(object?.timeBuckets)
        ? object.timeBuckets.map((e: any) => SuperChartConfiguration_TimeBucket.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebsiteSuperChartConfiguration): unknown {
    const obj: any = {};
    if (message.dateRanges?.length) {
      obj.dateRanges = message.dateRanges.map((e) => SuperChartConfiguration_DateRange.toJSON(e));
    }
    if (message.timeBuckets?.length) {
      obj.timeBuckets = message.timeBuckets.map((e) => SuperChartConfiguration_TimeBucket.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebsiteSuperChartConfiguration>, I>>(base?: I): WebsiteSuperChartConfiguration {
    return WebsiteSuperChartConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebsiteSuperChartConfiguration>, I>>(
    object: I,
  ): WebsiteSuperChartConfiguration {
    const message = createBaseWebsiteSuperChartConfiguration();
    message.dateRanges = object.dateRanges?.map((e) => SuperChartConfiguration_DateRange.fromPartial(e)) || [];
    message.timeBuckets = object.timeBuckets?.map((e) => SuperChartConfiguration_TimeBucket.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
